// Mock data para fluenceIA.com

export const heroData = {
  title: "Tu negocio puede ir más rápido.",
  subtitle: "Yo te enseño cómo sin complicaciones.",
  description: "Soy Emilio, con más de 25 años de experiencia en banca ayudando a empresarios a tomar decisiones. Ahora ayudo a pequeños negocios y autónomos a automatizar procesos con IA de forma cercana y sin tecnicismos.",
  ctaPrimary: "Reserva una llamada gratuita",
  ctaSecondary: "Conoce los servicios",
  backgroundImage: "https://images.unsplash.com/photo-1770169272345-9636d5ef2681"
};

export const problemsData = [
{
  id: 1,
  title: "Pierdes horas en tareas repetitivas",
  description: "Facturas, emails, seguimientos... tareas que podrías automatizar y dedicar ese tiempo a lo que realmente importa.",
  icon: "clock"
},
{
  id: 2,
  title: "No sabes por dónde empezar con la IA",
  description: "Hay miles de herramientas, pero nadie te explica cuál necesitas realmente para tu negocio específico.",
  icon: "help-circle"
},
{
  id: 3,
  title: "Tu competencia avanza y tú te quedas atrás",
  description: "Ves que otros negocios son más eficientes, pero no sabes cómo lo hacen ni cómo dar el paso tú también.",
  icon: "trending-down"
},
{
  id: 4,
  title: "No tienes tiempo para investigar",
  description: "Entre clientes, proveedores y el día a día, no te queda tiempo para aprender sobre nuevas tecnologías.",
  icon: "calendar-x"
}];


export const servicesData = [
{
  id: 1,
  title: "Diagnóstico de Automatización",
  description: "Sesión inicial personalizada donde analizamos tu negocio y identificamos exactamente qué procesos puedes automatizar para ahorrar tiempo y dinero.",
  features: [
  "Análisis completo de tus procesos actuales",
  "Identificación de oportunidades de automatización",
  "Roadmap personalizado de implementación",
  "Estimación de tiempo y recursos ahorrados"],

  icon: "search",
  image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40",
  price: ""
},
{
  id: 2,
  title: "Implementación a Medida",
  description: "Configuramos y ponemos en marcha las automatizaciones específicas que tu negocio necesita, adaptadas a tu forma de trabajar.",
  features: [
  "Configuración de herramientas de IA",
  "Automatización de procesos clave",
  "Integración con tus sistemas actuales",
  "Pruebas y ajustes hasta que funcione perfecto"],

  icon: "settings",
  image: "https://images.pexels.com/photos/5816285/pexels-photo-5816285.jpeg",
  price: ""
},
{
  id: 3,
  title: "Acompañamiento y Formación",
  description: "Tu equipo aprende a usar las herramientas de forma autónoma. Te acompaño hasta que os sintáis seguros y podáis aprovechar al máximo la automatización.",
  features: [
  "Formación práctica para tu equipo",
  "Soporte continuo durante la adaptación",
  "Documentación personalizada",
  "Seguimiento mensual de resultados"],

  icon: "users",
  image: "https://images.unsplash.com/photo-1573164574511-73c773193279",
  price: ""
}];


export const processData = {
  title: "¿Cómo trabajo?",
  subtitle: "Un proceso sencillo y transparente",
  steps: [
  {
    number: "01",
    title: "Llamada gratuita",
    description: "Hablamos 30 minutos sin compromiso. Me cuentas tu situación y te digo si puedo ayudarte y cómo."
  },
  {
    number: "02",
    title: "Diagnóstico",
    description: "Analizamos juntos tu negocio para identificar exactamente qué automatizar y en qué orden."
  },
  {
    number: "03",
    title: "Implementación",
    description: "Configuramos las automatizaciones paso a paso. Tú ves cómo funciona todo en tiempo real."
  },
  {
    number: "04",
    title: "Seguimiento",
    description: "Te acompaño hasta que domines las herramientas. Y seguimos en contacto para nuevas mejoras."
  }]

};

export const aboutData = {
  name: "Emilio Sáez Yebra",
  title: "Consultor de Automatización con IA",
  image: "https://customer-assets.emergentagent.com/job_negocio-rapido-2/artifacts/kvmydjr5_ChatGPT%20Image%2013%20ene%202026%2C%2022_26_53.png",
  description: "Después de más de 25 años como director de sucursal bancaria, conozco de primera mano los desafíos reales del pequeño empresario y del autónomo.",
  story: [
  "Durante años he ayudado a empresarios a tomar las mejores decisiones financieras para sus negocios. He visto de cerca qué funciona y qué no, qué preocupa realmente a quien tiene un negocio.",
  "Ahora he dado un paso más: ayudo a esos mismos empresarios a hacer crecer sus negocios usando inteligencia artificial de forma práctica y sin complicaciones técnicas.",
  "Mi diferencial no es ser un tecnólogo, sino entender tu negocio. Hablo tu idioma, no el de los informáticos. Y por eso sé exactamente qué necesitas y cómo implementarlo sin que te compliques la vida."],

  stats: [
  { number: "25+", label: "Años de experiencia" },
  { number: "100+", label: "Empresarios asesorados" },
  { number: "50+", label: "Procesos automatizados" }]

};

export const testimonialsData = [
{
  id: 1,
  name: "María González",
  role: "Directora de Despacho de Abogados",
  company: "González & Asociados",
  image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
  text: "Emilio nos ayudó a automatizar la gestión de expedientes y el seguimiento de clientes. Ahora ahorramos más de 10 horas semanales en tareas administrativas.",
  rating: 5
},
{
  id: 2,
  name: "Carlos Martínez",
  role: "Gerente",
  company: "Martínez Gestión y Asesoría",
  image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
  text: "Lo mejor de trabajar con Emilio es que habla claro, sin tecnicismos. Entendió perfectamente nuestras necesidades y nos dio soluciones prácticas que funcionan.",
  rating: 5
},
{
  id: 3,
  name: "Laura Ruiz",
  role: "Propietaria",
  company: "Estudio de Arquitectura Ruiz",
  image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
  text: "Implementamos automatizaciones en presupuestos y seguimiento de proyectos. El ROI fue inmediato. En 3 meses recuperamos la inversión solo en tiempo ahorrado.",
  rating: 5
}];


export const faqData = [
{
  id: 1,
  question: "¿Necesito conocimientos técnicos?",
  answer: "Para nada. Precisamente trabajo contigo porque no necesitas ser experto en tecnología. Yo me encargo de toda la parte técnica y te explico todo en lenguaje claro."
},
{
  id: 2,
  question: "¿Cuánto tiempo lleva implementar las automatizaciones?",
  answer: "Depende de la complejidad, pero la mayoría de automatizaciones básicas están funcionando en 2-4 semanas. Las más complejas pueden llevar 1-2 meses."
},
{
  id: 3,
  question: "¿Qué pasa si no sé qué procesos automatizar?",
  answer: "Eso es exactamente para lo que está la sesión de diagnóstico. Analizamos juntos tu día a día y te digo exactamente qué vale la pena automatizar y en qué orden."
},
{
  id: 4,
  question: "¿Las herramientas de IA son caras?",
  answer: "No necesariamente. Muchas herramientas tienen versiones gratuitas o planes desde 10-20€/mes. Y el ahorro en tiempo suele ser mucho mayor que el coste de las herramientas."
},
{
  id: 5,
  question: "¿Me acompañarás después de la implementación?",
  answer: "Sí, totalmente. Incluyo seguimiento hasta que te sientas seguro usando las automatizaciones. Y puedes seguir contando conmigo para nuevas mejoras o dudas."
}];


export const ctaFinalData = {
  title: "¿Listo para hacer tu negocio más eficiente?",
  subtitle: "Reserva una llamada gratuita de 30 minutos y descubre cómo la IA puede ayudarte",
  buttonText: "Reserva tu llamada gratuita",
  benefits: [
  "Sin compromiso",
  "30 minutos de consultoría gratis",
  "Análisis inicial de tu situación"]

};

export const linkedInPostsData = [
{
  id: 1,
  date: "Hace 1 semana",
  title: "2026 ya no es el futuro. Es el presente donde los AGENTES DE IA están redefiniendo las reglas del juego empresarial.",
  excerpt: "Mientras muchos siguen hablando de ChatGPT, algo mucho más grande está ocurriendo: El 80% de aplicaciones enterprise ya integran agentes de IA...",
  content: `🔥 LA REVOLUCIÓN SILENCIOSA

Mientras muchos siguen hablando de ChatGPT, algo mucho más grande está ocurriendo:

→ El 80% de aplicaciones enterprise ya integran agentes de IA
→ Empresas reducen tiempos de respuesta de 42 horas a TIEMPO REAL
→ Los agentes ya no solo responden: EJECUTAN, DECIDEN y ACTÚAN

La diferencia es brutal:

❌ Chatbot 2024: "¿Cuál es el mejor hotel?"
✅ Agente IA 2026: Busca, compara, reserva, paga y confirma

Sin que muevas un dedo.`,
  keyPoints: [
  "INTELIGENCIA AMBIENTAL - IA que actúa sin que se lo pidas",
  "AGENTES QUE HABLAN ENTRE SÍ - Coordinación automática",
  "ENTORNOS DE SIMULACIÓN - 99% de precisión estándar",
  "INTELIGENCIA GENERAL EMPRESARIAL - Consistencia en tareas complejas",
  "INTELIGENCIA ESPACIAL - Comprensión del mundo físico en 3D"],

  url: "https://www.linkedin.com/feed/update/urn:li:activity:7452250124279377920/",
  hashtags: ["InteligenciaArtificial", "AgentesIA", "IA2026"]
},
{
  id: 2,
  date: "Hace 5 días",
  title: "2026 ya NO es el año de los chatbots. Es el año de los AGENTES que EJECUTAN.",
  excerpt: "La revolución real está ocurriendo AHORA: Sistemas multiagente que coordinan tareas complejas...",
  content: `Durante años hemos visto copilotos que sugieren, asistentes que responden, herramientas que ayudan.

Pero la revolución real está ocurriendo AHORA:

→ Sistemas multiagente que coordinan tareas complejas
→ IA que actúa de forma autónoma bajo supervisión humana 
→ Agentes especializados que se comunican entre sí

La diferencia es brutal:

ANTES: "La IA me ayuda a redactar un email"
AHORA: "La IA detecta el problema, coordina la solución y ejecuta la acción"`,
  keyPoints: [
  "INTELIGENCIA AMBIENTAL - La IA actúa de forma proactiva",
  "SISTEMAS MULTIAGENTE - Agentes especializados que colaboran",
  "AI-READY DATA - El dato se convierte en palanca de acción"],

  url: "https://www.linkedin.com/feed/update/urn:li:share:7450136338714079232/",
  hashtags: ["InteligenciaArtificial", "AgentesIA", "TransformaciónDigital", "SistemasMultiagente"]
}];


// Mock function for form submission
export const submitContactForm = async (formData) => {
  // Simulate API call
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Formulario enviado correctamente" });
    }, 1000);
  });
};